"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttendeeTile = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Tile = require("./Tile");
var _AttendeeDisabledCamera = _interopRequireDefault(require("./AttendeeDisabledCamera"));
var _CameraOffState = require("../CameraOffState/CameraOffState");
var _branding = require("../../utils/Branding/branding");
var _getHeightExcludingBanner = require("../../utils/Branding/getHeightExcludingBanner");
var _Banners = require("../../constants/Banners");
var _dimensions = require("../../utils/Dimensions/dimensions");
var AttendeeTile = exports.AttendeeTile = function AttendeeTile(_ref) {
  var _attendeeTiles$attend;
  var attendeeId = _ref.attendeeId,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    _ref$isCameraOn = _ref.isCameraOn,
    isCameraOn = _ref$isCameraOn === void 0 ? true : _ref$isCameraOn,
    onThumbnailReady = _ref.onThumbnailReady,
    type = _ref.type,
    user = _ref.user,
    style = _ref.style;
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref2) {
      var broadcast = _ref2.broadcast,
        banners = _ref2.banners;
      return {
        broadcast: broadcast,
        banners: banners
      };
    }, _reactRedux.shallowEqual),
    broadcast = _useSelector.broadcast,
    banners = _useSelector.banners;
  if (!isCameraOn) {
    var _broadcast$settings;
    if ((0, _branding.isBrandingCameraOffFeatureEnabled)(broadcast === null || broadcast === void 0 || (_broadcast$settings = broadcast.settings) === null || _broadcast$settings === void 0 ? void 0 : _broadcast$settings.branding)) {
      var _presenterBanner$sour;
      var _style$height = style.height,
        height = _style$height === void 0 ? 0 : _style$height,
        _style$width = style.width,
        width = _style$width === void 0 ? 0 : _style$width;

      /* If namecard is shown on stage, subtract nameCard banner height
      from cameraOff component height to exclude namecard from cameraOff component*/

      //Find if there is any banner present, so that we can find if nameCard is toggle ON
      var presenterBanner = !banners || !Array.isArray(banners) ? null : banners.find(function (banner) {
        var _banner$source;
        return ((_banner$source = banner.source) === null || _banner$source === void 0 || (_banner$source = _banner$source.value) === null || _banner$source === void 0 ? void 0 : _banner$source.templateType) === _Banners.PRESENTER_BANNER;
      });
      var isToggledOff = presenterBanner === null || presenterBanner === void 0 || (_presenterBanner$sour = presenterBanner.source) === null || _presenterBanner$sour === void 0 ? void 0 : _presenterBanner$sour.hidden;
      height = parseFloat(height);
      var cameraOffHeight = !isToggledOff ? (0, _getHeightExcludingBanner.getHeightExcludingBanner)(height, (0, _dimensions.getElementHeight)("#banner-".concat(user.id))) : height;
      cameraOffHeight = Math.ceil(cameraOffHeight);
      return /*#__PURE__*/_react["default"].createElement(_CameraOffState.CameraOffState, {
        isStage: true,
        user: user,
        height: "".concat(cameraOffHeight, "px"),
        width: "".concat(width, "px")
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(_AttendeeDisabledCamera["default"], null);
    }
  }
  if (!attendeeTiles[attendeeId]) return null;
  var tile = attendeeTiles === null || attendeeTiles === void 0 || (_attendeeTiles$attend = attendeeTiles[attendeeId]) === null || _attendeeTiles$attend === void 0 ? void 0 : _attendeeTiles$attend[0];
  var tileId = tile === null || tile === void 0 ? void 0 : tile.tileId;
  return /*#__PURE__*/_react["default"].createElement(_Tile.Tile, {
    tileId: tileId,
    tile: tile,
    meetingSession: meetingSession,
    onThumbnailReady: onThumbnailReady,
    type: type
  });
};
AttendeeTile.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  isCameraOn: _propTypes["default"].bool,
  onThumbnailReady: _propTypes["default"].func,
  type: _propTypes["default"].string,
  user: _propTypes["default"].object,
  style: _propTypes["default"].object
};